import React, { useState, useEffect, useRef, lazy } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector } from "react-redux"; // useDispatch

//API
import ItemService from "../../../../services/customer_v2_appCommonService";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import supplierService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import ApproveRemarksModal from "../../../../Components/Modal/supplier_app/ApproveRemarksModal";
import toast from "react-hot-toast";
import { InputField } from "../../../../Components/formElements/InputField";
import { useReactToPrint } from "react-to-print";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
// import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";

let ewayBillNumberData = [
  {
    id: "1",
    name: "Yes",
    code: "YES",
    description: "Yes",
  },
  {
    id: "2",
    name: "No",
    code: "NO",
    description: "No",
  },
];
let accountsStatusNumberData = [
  {
    id: "1",
    name: "Hold",
    code: "HOL",
    description: "Hold",
  },
  {
    id: "2",
    name: "Cancelled",
    code: "CAN",
    description: "Cancelled",
  },
  {
    id: "3",
    name: "Done",
    code: "DON",
    description: "Done",
  },
  {
    id: "4",
    name: "Pending",
    code: "PEN",
    description: "Pending",
  },
  {
    id: "5",
    name: "Reconciliation",
    code: "REC",
    description: "Reconciliation",
  },
];
let tallySatatus = [
  {
    id: "1",
    name: "Updated",
    code: "UPD",
    description: "Updated",
  },
  {
    id: "2",
    name: "Pending",
    code: "PEN",
    description: "Pending",
  },
];
const signImages = {
  digitalSign1: "/assets/img/medirent/invoicesign/sign1dm.png",
  digitalSign2: "/assets/img/medirent/invoicesign/sign2sinrexct.png",
  digitalSign3: "/assets/img/medirent/invoicesign/sign3actex.png",
};
const ERFInvoiceDetailsV5 = () => {
  localStorage.setItem("menu", "Sales");
  localStorage.setItem("submenu", "Invoice");

  const pageStyle = `
  @page {
    size: A4 portrait; /* Sets the paper size to A3, in portrait orientation */
    margin: 10mm;     /* Optional: Sets a small margin for the page */
  }
 
  /* Optional: Targeting the body inside the print document for better fill */
  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
    }
  }
`;

  const ErfRentPrintInvoiceLazy = lazy(() => import("./ERFRentPrintInvoice"));
  const ErfSalePrintInvoiceLazy = lazy(() => import("./ERFSalePrintInvoice"));
  const ErfNursingPrintInvoiceLazy = lazy(
    () => import("./ERFNursingPrintInvoice"),
  );
  const ErfServicePrintInvoiceLazy = lazy(
    () => import("./ERFServicePrintInvoice"),
  );
  const ServiceVisitPrintInvoiceLazy = lazy(
    () => import("./ServiceVisitPrintInvoice"),
  );

  let invoiceNumber = useSelector((state) => state?.preSales?.invoiceID); // invoiceNumber from Store

  // let workflow = useSelector(
  //   (state) => state?.purchasing?.purchase_order?.workflowPO,
  // );

  const documentTypeMap = {
    "101 - GST Registration": "GST",
    "100 - PAN Registration": "PAN",
    "131 - GST Registration": "GST",
  };

  const [lineItemData, setLineItemData] = useState([]);
  const [saleLineItemData, setSaleLineItemData] = useState([]);
  const [nursingItemsData, setNursingItemsData] = useState([]);
  const [serviceItemsData, setServiceItemsData] = useState([]);

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);
  const [isCardVisible11, setCardVisible11] = useState(true);
  const [isCardVisible12, setCardVisible12] = useState(true);
  // eslint-disable-next-line
  const [modalShow, setModalShow] = useState(false);

  const [invoiceData, setInvoiceData] = useState({});
  // send print data
  const [printInvoiceData, setPrintInvoiceData] = useState();
  // eslint-disable-next-line
  const [getInvoiceChildData, setInvoiceChildData] = useState();

  const [showPrint, setShowPrint] = useState(false);
  const [showPrintSale, setShowPrintSale] = useState(false);
  const [showPrintNursing, setShowPrintNursing] = useState(false);
  const [showPrintService, setShowPrintService] = useState(false);
  const [showPrintServiceVisit, setShowPrintServiceVisit] = useState(false);

  const [getDropdownData, setDropdownData] = useState("");

  const isEquipmentServiceVisit =
    invoiceData?.invoiceCategory === "SERVICE_VISIT";

  // useEffect(() => {
  //   setInvoiceData((invoiceData) => ({
  //     ...invoiceData,
  //     [getDropdownData?.textField]: getDropdownData?.name,
  //     [getDropdownData?.textCode]: getDropdownData?.code,
  //     [getDropdownData?.textDesc]: getDropdownData?.description,
  //   }));
  // }, [getDropdownData]);
  useEffect(() => {
    if (!getDropdownData?.textField) return; // 👈 guard against empty runs
    setInvoiceData((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.code,
      [getDropdownData?.textDesc]: getDropdownData?.description,
    }));
  }, [getDropdownData]);
  //print
  useEffect(() => {
    setPrintInvoiceData(invoiceData);
  }, [invoiceData]);

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    // content: () => contentRef.current,
    documentTitle: `Invoice_${invoiceData?.documentNumber}`,
    onAfterPrint: () => setShowPrint(false),
    pageStyle: pageStyle,
  });
  const handlePrintSale = useReactToPrint({
    contentRef,
    // content: () => contentRef.current,
    documentTitle: `Invoice_${invoiceData?.documentNumber}`,
    onAfterPrint: () => setShowPrintSale(false),
    pageStyle: pageStyle,
  });
  const handlePrintNursing = useReactToPrint({
    contentRef,
    // content: () => contentRef.current,
    documentTitle: `Invoice_${invoiceData?.documentNumber}`,
    onAfterPrint: () => setShowPrintNursing(false),
    pageStyle: pageStyle,
  });
  const handlePrintService = useReactToPrint({
    contentRef,
    documentTitle: `Invoice_${invoiceData?.documentNumber}`,
    onAfterPrint: () => setShowPrintService(false),
    pageStyle: pageStyle,
  });
  const handlePrintServiceVisit = useReactToPrint({
    contentRef,
    documentTitle: `Invoice_${invoiceData?.documentNumber}`,
    onAfterPrint: () => setShowPrintServiceVisit(false),
    pageStyle: pageStyle,
  });

  useEffect(() => {
    if (showPrint) {
      setTimeout(() => {
        handlePrint();
      }, 300);
    }
    // eslint-disable-next-line
  }, [showPrint]);

  useEffect(() => {
    if (showPrintSale) {
      setTimeout(() => {
        handlePrintSale();
      }, 300);
    }
    // eslint-disable-next-line
  }, [showPrintSale]);

  useEffect(() => {
    if (showPrintNursing) {
      setTimeout(() => {
        handlePrintNursing();
      }, 300);
    }
    // eslint-disable-next-line
  }, [showPrintNursing]);
  useEffect(() => {
    if (showPrintService) {
      setTimeout(() => {
        handlePrintService();
      }, 300);
    }
    // eslint-disable-next-line
  }, [showPrintService]);

  useEffect(() => {
    if (showPrintServiceVisit) {
      setTimeout(() => handlePrintServiceVisit(), 300);
    }
    // eslint-disable-next-line
  }, [showPrintServiceVisit]);

  const lineItemCol = [
    {
      name: "SlNo.",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.equipmentItemNr} </p>
        </div>
      ),
      width: "80px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription} </p>
          <p className="m-0 p-0">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row?.orderedQuantity} </p>
          <p className="m-0 p-0">{row?.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Barcode",
      selector: (row) => row?.barcode,
      sortable: true,
      width: "140px",
    },
    {
      name: "From Date",
      selector: (row) => row?.fromDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "To Date",
      selector: (row) => row?.toDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Rent Slab",
      selector: (row) => row?.rentSlab,
      sortable: true,
      width: "140px",
    },

    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "GST(%)",
      selector: (row) => row?.taxPercentage || "--",
      cell: (row) => <span>{row?.taxPercentage} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "Tax Amt",
      selector: (row) => row?.taxAmount || "--",
      cell: (row) => <span>{row?.taxAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Gross Amt",
      selector: (row) => row?.grossValue || "--",
      cell: (row) => <span>{row?.grossValue} </span>,

      sortable: true,
      width: "120px",
    },
  ];

  const saleLineItemCol = [
    {
      name: "SlNo.",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.equipmentItemNr} </p>
        </div>
      ),
      width: "80px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription} </p>
          <p className="m-0 p-0">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row?.orderedQuantity} </p>
          <p className="m-0 p-0">{row?.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Barcode",
      selector: (row) => row?.barcode,
      sortable: true,
      width: "140px",
    },
    {
      name: "Date",
      selector: (row) => row?.fromDate,
      sortable: true,
      width: "140px",
    },

    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "GST(%)",
      selector: (row) => row?.taxPercentage || "--",
      cell: (row) => <span>{row?.taxPercentage} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "Tax Amt",
      selector: (row) => row?.taxAmount || "--",
      cell: (row) => <span>{row?.taxAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Gross Amt",
      selector: (row) => row?.grossValue || "--",
      cell: (row) => <span>{row?.grossValue} </span>,

      sortable: true,
      width: "120px",
    },
  ];
  const nursingItemsCol = [
    {
      name: "SlNo.",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.equipmentItemNr} </p>
        </div>
      ),
      width: "80px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription} </p>
          <p className="m-0 p-0">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row?.orderedQuantity} </p>
          <p className="m-0 p-0">{row?.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Barcode",
      selector: (row) => row?.barcode,
      sortable: true,
      width: "140px",
    },
    {
      name: "Date",
      selector: (row) => row?.fromDate,
      sortable: true,
      width: "140px",
    },

    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "GST(%)",
      selector: (row) => row?.taxPercentage || "--",
      cell: (row) => <span>{row?.taxPercentage} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "Tax Amt",
      selector: (row) => row?.taxAmount || "--",
      cell: (row) => <span>{row?.taxAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Gross Amt",
      selector: (row) => row?.grossValue || "--",
      cell: (row) => <span>{row?.grossValue} </span>,

      sortable: true,
      width: "120px",
    },
  ];

  const serviceItemsCol = [
    {
      name: "SlNo.",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.equipmentItemNr}</p>
        </div>
      ),
      width: "80px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription}</p>
          <p className="m-0 p-0">{row?.materialCode}</p>
        </div>
      ),
      width: "150px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row?.orderedQuantity}</p>
          <p className="m-0 p-0">{row?.orderUnitOfMeasure}</p>
        </div>
      ),
      width: "100px",
    },
    {
      name: "Date",
      selector: (row) => row?.fromDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "GST(%)",
      selector: (row) => row?.taxPercentage || "--",
      cell: (row) => <span>{row?.taxPercentage}</span>,
      sortable: true,
      width: "100px",
    },
    {
      name: "Tax Amt",
      selector: (row) => row?.taxAmount || "--",
      cell: (row) => <span>{row?.taxAmount}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Gross Amt",
      selector: (row) => row?.grossValue || "--",
      cell: (row) => <span>{row?.grossValue}</span>,
      sortable: true,
      width: "120px",
    },
  ];

  const equipmentServiceColumns = [
    {
      name: "SlNo.",
      cell: (_, i) => <p className="m-0 p-0">{i + 1}</p>,
      width: "80px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.materialDescription}</p>
          <p className="m-0 p-0">{row?.materialCode}</p>
        </div>
      ),
      width: "200px",
    },
    {
      name: "Item Type",
      selector: (row) => row?.itemType || "--",
      width: "110px",
    },
    {
      name: "Service Action",
      cell: (row) => (
        <span
          className={`badge ${
            row.serviceAction === "Replacement"
              ? "bg-warning text-dark"
              : "bg-info text-dark"
          }`}
        >
          {row.serviceAction || "--"}
        </span>
      ),
      width: "160px",
    },
    {
      name: "Current Barcode",
      selector: (row) => row?.currentBarcode || "--",
      width: "180px",
    },
    {
      name: "New / Returned Barcode",
      selector: (row) => row?.newBarcode || row?.returnedBarcode || "--",
      width: "220px",
    },
  ];

  const [formInputs, setFormInputs] = useState({
    transactionActivity: "INV",
    subTransactionActivity: "GRN",
    customerCode: "",
    purchasingDocumentNr: "",
    purchasingDocumentDate: "",
    purchasingDocumentValue: "",
    currency: "",
    currencyCode: "",
    paymentTerms: "",
    totalInvoiceAmount: "",
    sumOfCurrentAmt: "",
    notes: "",
    weighSlipQty: "",
    itemClass: "",
    customerInvoiceNo: "",
    customerInvoiceDate: "",
    customerInvoiceCurrency: "",
    customerBasicValue: "",
    customerFreightValue: "",
    customerTaxValue: "",
    customerOtherChargesValue: "",
    customerTotalInvoiceValue: "",
    invoicedValue: "",
    generatedBy: "",
    createdBy: "",
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const toggleCardVisibility11 = () => {
    setCardVisible11(!isCardVisible11);
  };
  const toggleCardVisibility12 = () => {
    setCardVisible12(!isCardVisible12);
  };

  // const onInputChange = ({ target: { name, value } }) => {
  //   setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  // };

  const onInputChange = ({ target: { name, value } }) => {
    // Check if it's a tally field → update invoiceData
    const tallyFields = ["tallyVoucherNo", "entryDate", "tallyRemarks"];
    if (tallyFields.includes(name)) {
      setInvoiceData((prev) => ({ ...prev, [name]: value }));
    } else {
      setFormInputs((prev) => ({ ...prev, [name]: value }));
    }
  };

  // load loadInitialPageData data on page load
  // const loadInitialPageData = async () => {
  //   // setLoading(true);
  //   if (invoiceNumber) {
  //     let obj = {
  //       documentNumber: invoiceNumber,
  //     };
  //     const toastId = toast.loading("Loading...", {
  //       position: "top-right",
  //     });

  //     await ItemService.getCustInvoiceDatails(obj).then((item) => {
  //       if (item?.status === 200) {
  //         setInvoiceData(item?.data[0]);
  //         setLineItemData(item?.data[0].rentItems);
  //         setSaleLineItemData(item?.data[0].saleItems);
  //         setNursingItemsData(item?.data[0].nursingItems);
  //         getCompanyDetails(item?.data[0].companyNr);

  //       } else {
  //         toast.error(item?.message || "Please try again !!", {
  //           duration: 4000,
  //           position: "top-right",
  //         });
  //       }
  //       toast.dismiss(toastId);
  //     });
  //     // setLoading(false);
  //   } else {
  //     window.history.back();
  //   }
  // };
  const loadInitialPageData = async () => {
    if (!invoiceNumber) {
      window.history.back();
      return;
    }

    const obj = { documentNumber: invoiceNumber };

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    try {
      const item = await ItemService.getCustInvoiceDatails(obj);

      if (item?.status === 200 && item?.data?.length > 0) {
        const invoice = item.data[0];

        setInvoiceData({
          ...invoice,
          digitalSign: false,
          tallyStatus: invoice?.tallyStatus || "Pending",
          tallyStatusCode: invoice?.tallyStatusCode || "PEN",
          tallyStatusDesc: invoice?.tallyStatusDesc || "Pending",
        });
        setLineItemData(invoice?.rentItems || []);
        setSaleLineItemData(invoice?.saleItems || []);
        setNursingItemsData(invoice?.nursingItems || []);
        setServiceItemsData(invoice?.serviceItems || []);

        getCompanyDetails(invoice?.companyNr);

        if (invoice?.signature) {
          await loadUploadedFiles(invoice.signature);
        }
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error loading invoice:", error);
      toast.error("Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
    }
  };

  useEffect(() => {
    loadInitialPageData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceNumber]);

  // Workflow
  const navigateToWorkflow = () => {
    window.history.back();
  };
  // const showApproveModal = async (name) => {
  //   setModalShow(true);
  //   // setAction(name);
  // };
  const printInvoiceDataChild = (childdData) => {
    setInvoiceChildData(childdData);
    // You can now use this data in the parent component
  };

  //get company details
  const [companyDetails, setCompanyDetails] = useState();

  const getCompanyDetails = async (id) => {
    try {
      const obj = {
        queryName: "Get_CompanyMaster_Details",

        documentNumber: id,
      };

      const res = await ItemServiceV2.generateCustomerQuery(obj);

      if (res?.status === 200 && res?.data) {
        const company = res.data?.[0];
        setCompanyDetails(company);

        // 🔹 Main form
        // setFormInputs(company);

        // // 🔹 Contact Persons
        // setcustomerContactPerson(company.contactDetails || []);

        // // 🔹 Documents
        // setDocumentTypeData(company.certifications || []);

        // // 🔹 Bank Details
        // // setBankDetails(company.bankDetails[0] || []);
        // setBankDetailsData(company.bankDetails[0] || []);

        // // 🔹 Company Profile
        // setCompanyProfile(company.companyProfile || {});
      }
    } catch (error) {
      console.error("Failed to load company details", error);
    }
  };
  // eslint-disable-next-line
  const [files, setFiles] = useState();
  // eslint-disable-next-line
  const [status, setStatus] = useState(true);

  const loadUploadedFiles = async (attachmentId) => {
    if (attachmentId) {
      let obj = {
        attachmentId,
      };
      setStatus(true);
      await supplierService.getUploadedFiles(obj).then((item) => {
        // setFiles(item.data[0]);
        setFiles(item?.data?.[item.data.length - 1] || null);
      });
      setStatus(false);
    } else {
      // alert('Please select a file first.');
    }
  };
  //check box change
  // eslint-disable-next-line
  const ochekboxChange = (e) => {
    const { name, checked } = e.target;

    setInvoiceData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  // eslint-disable-next-line
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };

  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  // eslint-disable-next-line
  const onSuccessUploadCreditNoteCard = (data) => {
    // 1. Get the system generated filename from results array
    const fileName =
      data?.results?.[0]?.newFilename || data?.results?.[0]?.fileName || "";
    const attachmentId = data?.attachmentId || "";

    if (!fileName || !attachmentId) {
      toast.error("Upload failed: Missing file details.");
      return;
    }

    // 2. Store both ID and FileName in state
    setInvoiceData((prev) => ({
      ...prev,
      creditNoteAttachment: attachmentId,
      creditNoteFileName: fileName,
    }));
    loadUploadedFiles(attachmentId);

    toast.success("uploaded successfully");
  };
  // eslint-disable-next-line
  const handleDeletePatientDocument = async (docType) => {
    let documentData = {};
    let successMessage = "";

    if (docType === "signature") {
      documentData = {
        attachmentId: invoiceData.signature,
        fileName: invoiceData?.aadharCardFileName,
      };
      successMessage = "Signature deleted successfully";
    } else if (docType === "creditNoteAttachment") {
      documentData = {
        attachmentId: invoiceData.creditNoteAttachment,
        fileName: invoiceData.creditNoteFileName,
      };
      successMessage = "Credit Note deleted successfully";
    }

    if (!documentData.attachmentId) {
      toast.error("No document to delete");
      return;
    }

    try {
      const response = await ItemService.deleteFile(documentData);

      if (response && response.message) {
        // 🔥 Clear correct state
        setInvoiceData((prev) => {
          if (docType === "signature") {
            return {
              ...prev,
              signature: "",
              aadharCardFileName: "",
            };
          } else if (docType === "creditNoteAttachment") {
            return {
              ...prev,
              creditNoteAttachment: "",
              creditNoteFileName: "",
            };
          }
        });

        toast.success(successMessage);
      } else {
        toast.error("Failed to delete document");
      }
    } catch (error) {
      console.error("Error deleting document:", error);
      toast.error("Error deleting document");
    }
  };
  const [disable, setDisabled] = useState(false);

  const [tallyUpdate, setTallyUPdate] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [editRentItems, setEditRentItems] = useState([]);
  const [editSaleItems, setEditSaleItems] = useState([]);
  const [editNursingItems, setEditNursingItems] = useState([]);
  const [editServiceItems, setEditServiceItems] = useState([]);

  // Number to words conversion (if needed for labels or totals)
  // ... (keep existing convertNumberToWords if it was there, though I didn't see it in the current file)

  const incrementVersion = (version) => {
    if (!version) return "V1";
    const num = parseInt(version.replace("V", ""), 10);
    return `V${num + 1}`;
  };

  //handle update
  const handleEditModeToggle = () => {
    if (!isEditMode) {
      setEditRentItems((lineItemData || []).map(calculateItemValues));
      setEditSaleItems((saleLineItemData || []).map(calculateItemValues));
      setEditNursingItems((nursingItemsData || []).map(calculateItemValues));
      setEditServiceItems((serviceItemsData || []).map(calculateItemValues));
      setIsEditMode(true);
    } else {
      setIsEditMode(false);
    }
  };

  const calculateItemValues = (item) => {
    const qty = Number(item.orderedQuantity) || 0;
    const taxPercent = Number(item.taxPercentage) || 0;

    let unitPrice = 0;
    if (item.rentSlab === "Per Day") {
      unitPrice = Number(item.rentPerDay) || 0;
    } else if (item.rentSlab === "7 Days") {
      unitPrice = Number(item.rent7Days) || 0;
    } else if (item.rentSlab === "15 Days") {
      unitPrice = Number(item.rent15Days) || 0;
    } else if (item.rentSlab === "30 Days") {
      unitPrice = Number(item.rent30Days) || 0;
    } else {
      unitPrice = Number(item.unitPrice || item.sellingPrice) || 0;
    }

    const netVal = qty * unitPrice;
    const netValueStr = netVal.toFixed(2);

    const currentNetVal = Number(netValueStr) || 0;
    const taxAmount = ((taxPercent / 100) * currentNetVal).toFixed(2);
    const grossValue = (currentNetVal + Number(taxAmount || 0)).toFixed(2);

    return {
      ...item,
      netValue: netValueStr,
      taxAmount: taxAmount,
      grossValue: grossValue,
    };
  };

  const handleLineItemChange = (type, index, field, value) => {
    const updateItem = (items) => {
      const newItems = [...items];
      const item = { ...newItems[index] };
      item[field] = value;

      newItems[index] = calculateItemValues(item);
      return newItems;
    };

    if (type === "rent") {
      setEditRentItems(updateItem(editRentItems));
    } else if (type === "sale") {
      setEditSaleItems(updateItem(editSaleItems));
    } else if (type === "nursing") {
      setEditNursingItems(updateItem(editNursingItems));
    } else if (type === "service") {
      setEditServiceItems(updateItem(editServiceItems));
    }
  };

  const calculateGlobalTotals = (items) => {
    const netTotal = items.reduce(
      (sum, item) => sum + (Number(item.netValue) || 0),
      0,
    );
    const taxTotal = items.reduce(
      (sum, item) => sum + (Number(item.taxAmount) || 0),
      0,
    );
    const grossTotal = items.reduce(
      (sum, item) => sum + (Number(item.grossValue) || 0),
      0,
    );
    return {
      netTotal: netTotal.toFixed(2),
      taxTotal: taxTotal.toFixed(2),
      grossTotal: grossTotal.toFixed(2),
    };
  };

  const handleUpdate = async () => {
    setDisabled(true);
    const toastId = toast.loading("Updating invoice...", {
      position: "top-right",
    });

    try {
      const rentTotals = calculateGlobalTotals(editRentItems);
      const saleTotals = calculateGlobalTotals(editSaleItems);
      const nursingTotals = calculateGlobalTotals(editNursingItems);
      const serviceTotals = calculateGlobalTotals(editServiceItems);

      const payload = {
        ...invoiceData,
        rentItems: editRentItems,
        saleItems: editSaleItems,
        nursingItems: editNursingItems,
        serviceItems: editServiceItems,
        version: incrementVersion(invoiceData?.version),
        rentNetTotal: rentTotals.netTotal,
        rentTaxTotal: rentTotals.taxTotal,
        rentGrossTotal: rentTotals.grossTotal,
        saleNetTotal: saleTotals.netTotal,
        saleTaxTotal: saleTotals.taxTotal,
        saleGrossTotal: saleTotals.grossTotal,
        nursingNetTotal: nursingTotals.netTotal,
        nursingTaxTotal: nursingTotals.taxTotal,
        nursingGrossTotal: nursingTotals.grossTotal,
        serviceNetTotal: serviceTotals.netTotal,
        serviceTaxTotal: serviceTotals.taxTotal,
        serviceGrossTotal: serviceTotals.grossTotal,
      };

      const response = await ItemService.updateInvoice(payload);

      if (response?.status === 200) {
        toast.success("Invoice updated successfully");

        // Update local state with new data
        setInvoiceData(payload);
        setLineItemData(editRentItems);
        setSaleLineItemData(editSaleItems);
        setNursingItemsData(editNursingItems);
        setServiceItemsData(editServiceItems);

        setIsEditMode(false);
      } else {
        toast.error(response?.message || "Update failed");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("An error occurred while updating");
    } finally {
      setDisabled(false);
      toast.dismiss(toastId);
    }
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Invoice Details :{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {invoiceNumber}
              </span>
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage ms-2">
                {invoiceData?.equipmentRentNr}
              </span>
              {/* <span className="headerStatusDetailedPage ms-2">
                <TableStatusField status={invoiceData.erfType} />
              </span> */}
              <span className="headerStatusDetailedPage ms-2">
                <TableStatusField
                  status={
                    isEquipmentServiceVisit
                      ? "Service Visit"
                      : invoiceData.erfType
                  }
                />
              </span>
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                Tally-{invoiceData?.tallyStatus}
              </span>
              <span>
                {formInputs?.invoiceStatusHeader === "Invoice Created" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.invoiceStatusHeader}
                  </span>
                ) : formInputs?.invoiceStatusHeader ===
                  "Pending for Approval" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs?.invoiceStatusHeader}
                  </span>
                ) : formInputs?.invoiceStatusHeader === "Invoice Approved" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.invoiceStatusHeader}
                  </span>
                ) : (
                  formInputs?.invoiceStatusHeader
                )}
              </span>
            </h2>
            <p className="subText">Invoice Details</p>
            <hr />

            <Row className="mb-4">
              <Col xs={12} md={6} lg={6} className="text-left">
                <button
                  className="btnBack"
                  onClick={() => navigateToWorkflow()}
                >
                  <i className="bi bi-arrow-return-left"></i> Go Back
                </button>
              </Col>
              {/* <Col xs={12} md={6} lg={6} className="text-right">
                {workflow?.workflow_record?.decision?.length > 0 &&
                  workflow?.workflow_record?.decision?.map((item, index) => (
                    <button
                      className={
                        item === "Approve" || item === "Submit"
                          ? "btnCommon btn-approve"
                          : "btnCommon btn-danger"
                      }
                      onClick={() => showApproveModal(item)}
                      key={index}
                    >
                      <i
                        className={
                          item === "Approve" || item === "Submit"
                            ? "bi bi-check2-circle"
                            : "bi bi-x-circle"
                        }
                      ></i>{" "}
                      {item}
                    </button>
                  ))}
              </Col> */}
              <Col
                xs={12}
                md={6}
                lg={6}
                className="d-flex justify-content-end text-left"
              >
                {!tallyUpdate && (
                  <>
                    {!isEditMode && (
                      <button
                        disabled={disable}
                        className="btn btnBack mx-2"
                        onClick={() => setTallyUPdate(true)}
                      >
                        <i class="bi bi-receipt"></i> Update Tally
                      </button>
                    )}
                    {isEditMode && (
                      <>
                        <button
                          disabled={disable}
                          className="btn btn-success mx-2"
                          onClick={handleUpdate}
                        >
                          <i className="bi bi-check-circle me-1"></i> Update
                        </button>
                        <button
                          disabled={disable}
                          className="btn btn-danger mx-2"
                          onClick={handleEditModeToggle}
                        >
                          <i className="bi bi-x-circle me-1"></i> Cancel
                        </button>
                      </>
                    )}
                    {/* {!isEditMode && (
                      <button
                        disabled={disable}
                        className="btn btnBack mx-2"
                        onClick={handleEditModeToggle}
                      >
                        <i className="bi bi-pencil-square me-1"></i> Edit
                        Invoice
                      </button>
                    )} */}
                    {!isEquipmentServiceVisit &&
                      !tallyUpdate &&
                      !isEditMode && (
                        <button
                          disabled={disable}
                          className="btn btnBack mx-2"
                          onClick={handleEditModeToggle}
                        >
                          <i className="bi bi-pencil-square me-1"></i> Edit
                          Invoice
                        </button>
                      )}
                  </>
                )}
                {tallyUpdate && (
                  <>
                    <button
                      disabled={disable}
                      className="btn btn-success mx-2"
                      onClick={handleUpdate}
                    >
                      <i className="bi bi-check-circle me-1"></i> Update
                    </button>
                    <button
                      disabled={disable}
                      className="btn btn-danger mx-2"
                      onClick={() => {
                        setTallyUPdate(false);
                      }}
                    >
                      <i className="bi bi-x-circle me-1"></i> Cancel
                    </button>
                  </>
                )}
                {isEquipmentServiceVisit ? (
                  <button
                    className="btnBack"
                    onClick={() => {
                      setShowPrintServiceVisit(true);
                      setTimeout(handlePrintServiceVisit, 0);
                    }}
                  >
                    <i className="bi bi-printer" /> Print Service Visit
                  </button>
                ) : (
                  <>
                    {(invoiceData?.erfTypeCode === "RE" ||
                      invoiceData?.erfTypeCode === "SLRE") && (
                      <button
                        className="btnBack"
                        onClick={() => {
                          setShowPrint(true);
                          setTimeout(handlePrint, 0);
                        }}
                      >
                        <i class="bi bi-printer"></i> Print Rent
                      </button>
                    )}
                    {(invoiceData?.erfTypeCode === "SL" ||
                      invoiceData?.erfTypeCode === "SLRE") && (
                      <button
                        className="btnBack"
                        onClick={() => {
                          setShowPrintSale(true);
                          setTimeout(handlePrintSale, 0);
                        }}
                      >
                        <i class="bi bi-printer"></i> Print Sale
                      </button>
                    )}
                    {invoiceData?.erfTypeCode === "NR" && (
                      <button
                        className="btnBack"
                        onClick={() => {
                          setShowPrintNursing(true);
                          setTimeout(handlePrintNursing, 0);
                        }}
                      >
                        <i class="bi bi-printer"></i> Print Nursing
                      </button>
                    )}
                    {invoiceData?.erfTypeCode === "SV" && (
                      <button
                        className="btnBack"
                        onClick={() => {
                          setShowPrintService(true);
                          setTimeout(handlePrintService, 0);
                        }}
                      >
                        <i className="bi bi-printer"></i> Print Service
                      </button>
                    )}
                  </>
                )}

                {showPrint && (
                  <>
                    <div /* style={{ display: "none" }} */ className="d-none">
                      <ErfRentPrintInvoiceLazy
                        ref={contentRef}
                        data={printInvoiceData}
                        companyDetails={companyDetails}
                        files={files}
                        onsendinvoicedata={printInvoiceDataChild}
                      />
                    </div>
                  </>
                )}
                {showPrintSale && (
                  <>
                    <div /* style={{ display: "none" }} */ className="d-none">
                      <ErfSalePrintInvoiceLazy
                        ref={contentRef}
                        data={printInvoiceData}
                        companyDetails={companyDetails}
                        files={files}
                        onsendinvoicedata={printInvoiceDataChild}
                      />
                    </div>
                  </>
                )}
                {showPrintNursing && (
                  <>
                    <div /* style={{ display: "none" }} */ className="d-none">
                      <ErfNursingPrintInvoiceLazy
                        ref={contentRef}
                        data={printInvoiceData}
                        companyDetails={companyDetails}
                        files={files}
                        onsendinvoicedata={printInvoiceDataChild}
                      />
                    </div>
                  </>
                )}
                {showPrintService && (
                  <>
                    <div className="d-none">
                      <ErfServicePrintInvoiceLazy
                        ref={contentRef}
                        data={printInvoiceData}
                        companyDetails={companyDetails}
                        files={files}
                        onsendinvoicedata={printInvoiceDataChild}
                      />
                    </div>
                  </>
                )}
                {showPrintServiceVisit && (
                  <div className="d-none">
                    <ServiceVisitPrintInvoiceLazy
                      ref={contentRef}
                      data={printInvoiceData}
                      companyDetails={companyDetails}
                      files={files}
                      onsendinvoicedata={printInvoiceDataChild}
                    />
                  </div>
                )}
              </Col>
            </Row>

            <>
              {tallyUpdate && (
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible10
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility10}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">TS</span>
                        </Col>

                        <Col xs={4} md={4} lg={4}>
                          <span className="headerTitle">Tally Status</span>
                          <span className="subHeaderTitle">
                            Accounts team tally voucher entry and reconciliation
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible10 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <div className="accordion-body">
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Tally Voucher No"
                                    name="tallyVoucherNo"
                                    id="tallyVoucherNo"
                                    value={invoiceData?.tallyVoucherNo}
                                    onChange={onInputChange}
                                    // disabled={invoiceData?.tallyVoucherNo}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Entry Date"
                                    name="entryDate"
                                    type="date"
                                    min={2000}
                                    id="entryDate"
                                    value={invoiceData?.entryDate}
                                    onChange={onInputChange}
                                    // disabled={invoiceData?.tallyVoucherNo}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Status"
                                    extraLabel=""
                                    name="tallyStatus"
                                    code="tallyStatusCode"
                                    description="tallyStatusDesc"
                                    data={tallySatatus}
                                    id="tallyStatus"
                                    iconClassName="dropdownIcon"
                                    setValue={
                                      invoiceData?.tallyStatus ||
                                      formInputs?.tallyStatus
                                    }
                                    getvalue={setDropdownData}
                                    // required={true}
                                    // disabled={invoiceData?.tallyVoucherNo}
                                    // disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <TextAreaField
                                    className="inputBox"
                                    label="Remarks"
                                    name="tallyRemarks"
                                    id="tallyRemarks"
                                    value={invoiceData?.tallyRemarks}
                                    // disabled={invoiceData?.tallyRemarks}
                                    onChange={onInputChange}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Invoice header */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">IH</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Invoice Header</span>
                        <span className="subHeaderTitle">Invoice Header</span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible ? "visible" : ""
                    }`}
                  >
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Col xs={12} md={12} lg={12} className="px-2">
                            {/* <p className="fw-bold mb-0">Company:</p> */}
                            <p className="text-lg mb-0 fw-bold">
                              {companyDetails?.firstName}
                            </p>
                            <p className="text-lg mb-0">
                              {companyDetails?.address +
                                " " +
                                companyDetails?.address2 +
                                " " +
                                companyDetails?.cityPostalCode}
                            </p>
                            <p className="m-0 p-0">
                              Email:{" "}
                              {companyDetails?.contactDetails[0]?.contactEmail}
                            </p>
                            <p className="m-0 p-0">
                              Contact No:{companyDetails?.mobileNr},
                              011-25522552
                              {/* {companyDetails?.contactDetails[0]?.contactNumber} */}
                            </p>
                            <p>
                              GST:{companyDetails?.gstNumebr}
                              {/* {companyDetails?.certifications.map((cert) => (
                            <div key={cert.id}>
                              {cert.documentType ===
                                "101 - GST Registration " && (
                                <p>GST : {cert.documentNumber}</p>
                              )}
                            </div>
                          ))} */}
                            </p>
                          </Col>
                          <Col xs={12} md={12} lg={12} className="px-2">
                            {invoiceData?.items?.length > 0 &&
                              Array.isArray(
                                invoiceData.items[0]?.companyCertifications,
                              ) &&
                              invoiceData.items[0].companyCertifications
                                .filter((doc) =>
                                  Object.keys(documentTypeMap).some((type) =>
                                    doc.documentType?.includes(type),
                                  ),
                                )
                                .map((doc, index) => {
                                  const title =
                                    documentTypeMap[doc.documentType] ||
                                    doc.documentType;

                                  return (
                                    <p key={index} className="text-lg mb-0">
                                      <b>{title}: </b> {doc.documentNumber}
                                    </p>
                                  );
                                })}
                          </Col>

                          <Row>
                            <Col xs={12} md={4} lg={4} className="ps-2">
                              <p className="fw-bold mb-0">Billing:</p>
                              <p className="text-lg mb-0">
                                {invoiceData?.billingName}
                              </p>
                              <p className="text-lg mb-0">
                                {invoiceData?.billingAddress}
                              </p>
                              <p className="text-lg mb-0">
                                {invoiceData?.billingState}
                                {invoiceData?.billingPinCode}
                              </p>
                            </Col>
                            <Col xs={6} md={6} lg={6}>
                              <Row>
                                <Col xs={12} md={12} lg={12} className="p-2">
                                  <p className="fw-bold mb-0">
                                    Delivery Address:
                                  </p>
                                  <p className="text-lg mb-0">
                                    {invoiceData?.deliveryAddress}
                                  </p>
                                  <p className="text-lg mb-0">
                                    {invoiceData?.deliveryState}
                                  </p>
                                  <p className="text-lg mb-0">
                                    {invoiceData?.deliveryPinCode}
                                  </p>
                                </Col>
                              </Row>
                            </Col>
                          </Row>

                          {/* <Row>
                            <Col xs={6} md={6} lg={6}>
                              <Row>
                                <Col xs={12} md={12} lg={12} className="p-2">
                                  <p className="fw-bold mb-0">
                                    {" "}
                                    Shipping Address:
                                  </p>
                                  <p className="text-lg mb-0">
                                    {companyDetails?.firstName}
                                  </p>
                                  <p className="text-lg mb-0">
                                    {companyDetails?.address +
                                      " " +
                                      companyDetails?.address2 +
                                      " " +
                                      companyDetails?.cityPostalCode}
                                  </p>
                                  <p className="m-0 p-0">
                                    Email:{" "}
                                    {
                                      companyDetails?.contactDetails[0]
                                        ?.contactEmail
                                    }
                                  </p>
                                  <p className="m-0 p-0">
                                    Phone No:
                                    {
                                      companyDetails?.contactDetails[0]
                                        ?.contactNumber
                                    }
                                  </p>
                                  <p>
                                    {companyDetails?.certifications.map(
                                      (cert) => (
                                        <div key={cert.id}>
                                          {cert.documentType ===
                                            "101 - GST Registration " && (
                                            <p>GST : {cert.documentNumber}</p>
                                          )}
                                        </div>
                                      ),
                                    )}
                                  </p>
                                </Col>
                              </Row>
                            </Col>
                            <Col xs={6} md={6} lg={6}>
                              <Row>
                                <Col xs={12} md={12} lg={12} className="p-2">
                                  <p className="fw-bold mb-0">
                                    Delivery Address:
                                  </p>
                                  <p className="text-lg mb-0">
                                    {invoiceData?.deliveryAddress}
                                  </p>
                                  <p className="text-lg mb-0">
                                    {invoiceData?.deliveryState}
                                  </p>
                                  <p className="text-lg mb-0">
                                    {invoiceData?.deliveryPinCode}
                                  </p>
                                </Col>
                              </Row>
                            </Col>
                          </Row> */}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>

              {/* rentItems */}
              {!isEquipmentServiceVisit &&
                Array.isArray(invoiceData?.rentItems) &&
                invoiceData.rentItems.length > 0 && (
                  <>
                    {/*02 */}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible2
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility2}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">RI</span>
                            </Col>

                            <Col xs={4} md={4} lg={4}>
                              <span className="headerTitle">Rent Items</span>
                              <span className="subHeaderTitle">
                                Rent Items details
                              </span>
                            </Col>
                          </Row>
                        </h2>

                        <div
                          // id="acc"
                          className={`accordion-collapse collapse show ${
                            isCardVisible2 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <div className="accordion-body">
                                  <Row className="pt-2 pb-4">
                                    {!isEditMode ? (
                                      <DataTable
                                        title=""
                                        columns={lineItemCol}
                                        data={lineItemData}
                                        pagination
                                        paginationServer
                                      />
                                    ) : (
                                      <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                          <thead className="table-light">
                                            <tr style={{ fontSize: "12px" }}>
                                              <th>SlNo.</th>
                                              <th>Product</th>
                                              <th>Qty</th>
                                              <th>Barcode</th>
                                              <th>From Date</th>
                                              <th>To Date</th>
                                              <th>Rent Slab</th>
                                              <th>Net Value</th>
                                              <th>GST(%)</th>
                                              <th>Tax Amt</th>
                                              <th>Gross Amt</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {editRentItems.map((row, index) => (
                                              <tr key={index}>
                                                <td
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {row?.equipmentItemNr}
                                                </td>
                                                <td>
                                                  <p
                                                    className="m-0 p-0 fw-bold"
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {row?.materialDescription}
                                                  </p>
                                                  <p
                                                    className="m-0 p-0"
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {row?.materialCode}
                                                  </p>
                                                </td>
                                                <td>
                                                  <InputField
                                                    type="number"
                                                    className="inputBox"
                                                    value={row?.orderedQuantity}
                                                    onChange={(e) =>
                                                      handleLineItemChange(
                                                        "rent",
                                                        index,
                                                        "orderedQuantity",
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                  <p
                                                    className="m-0 p-0 text-muted small"
                                                    style={{ fontSize: "10px" }}
                                                  >
                                                    {row?.orderUnitOfMeasure}
                                                  </p>
                                                </td>
                                                <td
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {row?.barcode}
                                                </td>
                                                <td>
                                                  <InputField
                                                    type="date"
                                                    className="inputBox"
                                                    value={row?.fromDate}
                                                    onChange={(e) =>
                                                      handleLineItemChange(
                                                        "rent",
                                                        index,
                                                        "fromDate",
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                </td>
                                                <td>
                                                  <InputField
                                                    type="date"
                                                    className="inputBox"
                                                    value={row?.toDate}
                                                    onChange={(e) =>
                                                      handleLineItemChange(
                                                        "rent",
                                                        index,
                                                        "toDate",
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                </td>
                                                <td
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {row?.rentSlab}
                                                </td>
                                                <td
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {row?.netValue}
                                                </td>
                                                <td>
                                                  <InputField
                                                    type="number"
                                                    className="inputBox"
                                                    value={row?.taxPercentage}
                                                    onChange={(e) =>
                                                      handleLineItemChange(
                                                        "rent",
                                                        index,
                                                        "taxPercentage",
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                </td>
                                                <td
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {row?.taxAmount}
                                                </td>
                                                <td
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {row?.grossValue}
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    )}
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*03 */}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible3
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility3}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">RD</span>
                            </Col>

                            <Col xs={4} md={4} lg={4}>
                              <span className="headerTitle">Rent details</span>
                              <span className="subHeaderTitle">
                                Rent details
                              </span>
                            </Col>
                          </Row>
                        </h2>

                        <div
                          // id="acc"
                          className={`accordion-collapse collapse show ${
                            isCardVisible3 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <div className="accordion-body">
                                  <Row className="pt-2 pb-4">
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Total Amount"
                                        name="rentNetTotal"
                                        id="rentNetTotal"
                                        value={
                                          isEditMode
                                            ? calculateGlobalTotals(
                                                editRentItems,
                                              ).netTotal
                                            : invoiceData?.rentNetTotal
                                        }
                                        onChange={onInputChange}
                                        disabled={true}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Total GST"
                                        name="rentTaxTotal"
                                        id="rentTaxTotal"
                                        value={
                                          isEditMode
                                            ? calculateGlobalTotals(
                                                editRentItems,
                                              ).taxTotal
                                            : invoiceData?.rentTaxTotal
                                        }
                                        onChange={onInputChange}
                                        disabled={true}
                                      />
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Gross Amount"
                                        name="rentGrossTotal"
                                        id="rentGrossTotal"
                                        value={
                                          isEditMode
                                            ? calculateGlobalTotals(
                                                editRentItems,
                                              ).grossTotal
                                            : invoiceData?.rentGrossTotal
                                        }
                                        onChange={onInputChange}
                                        disabled={true}
                                      />
                                    </Col>
                                    {/* <Row>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="e-Way Bill Number"
                              extraLabel=""
                              name="ewayBill"
                              code="ewayBillCode"
                              description="ewayBillDesc"
                              data={ewayBillNumberData}
                              id="ewayBill"
                              iconClassName="dropdownIcon"
                              setValue={invoiceData?.ewayBill}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={false}
                            />
                          </Col>                
                       </Row> */}
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              {/* saleItems */}
              {!isEquipmentServiceVisit &&
                Array.isArray(invoiceData?.saleItems) &&
                invoiceData.saleItems.length > 0 && (
                  <>
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible4
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility4}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">RI</span>
                            </Col>

                            <Col xs={4} md={4} lg={4}>
                              <span className="headerTitle">Sale Items</span>
                              <span className="subHeaderTitle">
                                Sale Items details
                              </span>
                            </Col>
                          </Row>
                        </h2>

                        <div
                          // id="acc"
                          className={`accordion-collapse collapse show ${
                            isCardVisible4 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <div className="accordion-body">
                                  <Row className="pt-2 pb-4">
                                    {!isEditMode ? (
                                      <DataTable
                                        title=""
                                        columns={saleLineItemCol}
                                        data={saleLineItemData}
                                        pagination
                                        paginationServer
                                      />
                                    ) : (
                                      <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                          <thead className="table-light">
                                            <tr style={{ fontSize: "12px" }}>
                                              <th>SlNo.</th>
                                              <th>Product</th>
                                              <th>Qty</th>
                                              <th>Barcode</th>
                                              <th>Date</th>
                                              <th>Net Value</th>
                                              <th>GST(%)</th>
                                              <th>Tax Amt</th>
                                              <th>Gross Amt</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {editSaleItems.map((row, index) => (
                                              <tr key={index}>
                                                <td
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {row?.equipmentItemNr}
                                                </td>
                                                <td>
                                                  <p
                                                    className="m-0 p-0 fw-bold"
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {row?.materialDescription}
                                                  </p>
                                                  <p
                                                    className="m-0 p-0"
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {row?.materialCode}
                                                  </p>
                                                </td>
                                                <td>
                                                  <InputField
                                                    type="number"
                                                    className="inputBox"
                                                    value={row?.orderedQuantity}
                                                    onChange={(e) =>
                                                      handleLineItemChange(
                                                        "sale",
                                                        index,
                                                        "orderedQuantity",
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                  <p
                                                    className="m-0 p-0 text-muted small"
                                                    style={{ fontSize: "10px" }}
                                                  >
                                                    {row?.orderUnitOfMeasure}
                                                  </p>
                                                </td>
                                                <td
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {row?.barcode}
                                                </td>
                                                <td>
                                                  <InputField
                                                    type="date"
                                                    className="inputBox"
                                                    value={row?.fromDate}
                                                    onChange={(e) =>
                                                      handleLineItemChange(
                                                        "sale",
                                                        index,
                                                        "fromDate",
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                </td>
                                                <td
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {row?.netValue}
                                                </td>
                                                <td>
                                                  <InputField
                                                    type="number"
                                                    className="inputBox"
                                                    value={row?.taxPercentage}
                                                    onChange={(e) =>
                                                      handleLineItemChange(
                                                        "sale",
                                                        index,
                                                        "taxPercentage",
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                </td>
                                                <td
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {row?.taxAmount}
                                                </td>
                                                <td
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {row?.grossValue}
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    )}
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/*03 */}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible5
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility5}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">SI</span>
                            </Col>

                            <Col xs={4} md={4} lg={4}>
                              <span className="headerTitle">Sale details</span>
                              <span className="subHeaderTitle">
                                Sale details
                              </span>
                            </Col>
                          </Row>
                        </h2>

                        <div
                          // id="acc"
                          className={`accordion-collapse collapse show ${
                            isCardVisible5 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <div className="accordion-body">
                                  <Row className="pt-2 pb-4">
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Net Total"
                                        name="saleNetTotal"
                                        id="saleNetTotal"
                                        value={
                                          isEditMode
                                            ? calculateGlobalTotals(
                                                editSaleItems,
                                              ).netTotal
                                            : invoiceData?.saleNetTotal
                                        }
                                        onChange={onInputChange}
                                        disabled={true}
                                      />
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Total GST"
                                        name="saleTaxTotal"
                                        id="saleTaxTotal"
                                        value={
                                          isEditMode
                                            ? calculateGlobalTotals(
                                                editSaleItems,
                                              ).taxTotal
                                            : invoiceData?.saleTaxTotal
                                        }
                                        onChange={onInputChange}
                                        disabled={true}
                                      />
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Gross Total"
                                        name="saleGrossTotal"
                                        id="saleGrossTotal"
                                        value={
                                          isEditMode
                                            ? calculateGlobalTotals(
                                                editSaleItems,
                                              ).grossTotal
                                            : invoiceData?.saleGrossTotal
                                        }
                                        onChange={onInputChange}
                                        disabled={true}
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              {/* nursingItems */}
              {!isEquipmentServiceVisit &&
                Array.isArray(invoiceData?.nursingItems) &&
                invoiceData.nursingItems.length > 0 && (
                  <>
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible6
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility6}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">NI</span>
                            </Col>

                            <Col xs={4} md={4} lg={4}>
                              <span className="headerTitle">Nursing Items</span>
                              <span className="subHeaderTitle">
                                Nursing Items details
                              </span>
                            </Col>
                          </Row>
                        </h2>

                        <div
                          // id="acc"
                          className={`accordion-collapse collapse show ${
                            isCardVisible6 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <div className="accordion-body">
                                  <Row className="pt-2 pb-4">
                                    {!isEditMode ? (
                                      <DataTable
                                        title=""
                                        columns={nursingItemsCol}
                                        data={nursingItemsData}
                                        pagination
                                        paginationServer
                                      />
                                    ) : (
                                      <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                          <thead className="table-light">
                                            <tr style={{ fontSize: "12px" }}>
                                              <th>SlNo.</th>
                                              <th>Product</th>
                                              <th>Qty</th>
                                              <th>Barcode</th>
                                              <th>Date</th>
                                              <th>Net Value</th>
                                              <th>GST(%)</th>
                                              <th>Tax Amt</th>
                                              <th>Gross Amt</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {editNursingItems.map(
                                              (row, index) => (
                                                <tr key={index}>
                                                  <td
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {row?.equipmentItemNr}
                                                  </td>
                                                  <td>
                                                    <p
                                                      className="m-0 p-0 fw-bold"
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      {row?.materialDescription}
                                                    </p>
                                                    <p
                                                      className="m-0 p-0"
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      {row?.materialCode}
                                                    </p>
                                                  </td>
                                                  <td>
                                                    <InputField
                                                      type="number"
                                                      className="inputBox"
                                                      value={
                                                        row?.orderedQuantity
                                                      }
                                                      onChange={(e) =>
                                                        handleLineItemChange(
                                                          "nursing",
                                                          index,
                                                          "orderedQuantity",
                                                          e.target.value,
                                                        )
                                                      }
                                                    />
                                                    <p
                                                      className="m-0 p-0 text-muted small"
                                                      style={{
                                                        fontSize: "10px",
                                                      }}
                                                    >
                                                      {row?.orderUnitOfMeasure}
                                                    </p>
                                                  </td>
                                                  <td
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {row?.barcode}
                                                  </td>
                                                  <td>
                                                    <InputField
                                                      type="date"
                                                      className="inputBox"
                                                      value={row?.fromDate}
                                                      onChange={(e) =>
                                                        handleLineItemChange(
                                                          "nursing",
                                                          index,
                                                          "fromDate",
                                                          e.target.value,
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                  <td
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {row?.netValue}
                                                  </td>
                                                  <td>
                                                    <InputField
                                                      type="number"
                                                      className="inputBox"
                                                      value={row?.taxPercentage}
                                                      onChange={(e) =>
                                                        handleLineItemChange(
                                                          "nursing",
                                                          index,
                                                          "taxPercentage",
                                                          e.target.value,
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                  <td
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {row?.taxAmount}
                                                  </td>
                                                  <td
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {row?.grossValue}
                                                  </td>
                                                </tr>
                                              ),
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    )}
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*03 */}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible7
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility7}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">ND</span>
                            </Col>

                            <Col xs={4} md={4} lg={4}>
                              <span className="headerTitle">
                                Nursing details
                              </span>
                              <span className="subHeaderTitle">
                                Nursing details
                              </span>
                            </Col>
                          </Row>
                        </h2>

                        <div
                          // id="acc"
                          className={`accordion-collapse collapse show ${
                            isCardVisible7 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <div className="accordion-body">
                                  <Row className="pt-2 pb-4">
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Net Total"
                                        name="nursingNetTotal"
                                        id="nursingNetTotal"
                                        value={invoiceData?.nursingNetTotal}
                                        onChange={onInputChange}
                                        disabled={true}
                                      />
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Total GST"
                                        name="nursingTaxTotal"
                                        id="nursingTaxTotal"
                                        value={invoiceData?.nursingTaxTotal}
                                        onChange={onInputChange}
                                        disabled={true}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Gross Amount"
                                        name="nursingGrossTotal"
                                        id="nursingGrossTotal"
                                        value={invoiceData?.nursingGrossTotal}
                                        onChange={onInputChange}
                                        disabled={true}
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

              {/* serviceItems */}
              {!isEquipmentServiceVisit &&
                Array.isArray(invoiceData?.serviceItems) &&
                invoiceData.serviceItems.length > 0 && (
                  <>
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible11
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility11}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">SV</span>
                            </Col>
                            <Col xs={4} md={4} lg={4}>
                              <span className="headerTitle">Service Items</span>
                              <span className="subHeaderTitle">
                                Service Items details
                              </span>
                            </Col>
                          </Row>
                        </h2>
                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible11 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <div className="accordion-body">
                                  <Row className="pt-2 pb-4">
                                    {!isEditMode ? (
                                      <DataTable
                                        title=""
                                        columns={serviceItemsCol}
                                        data={serviceItemsData}
                                        pagination
                                        paginationServer
                                      />
                                    ) : (
                                      <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                          <thead className="table-light">
                                            <tr style={{ fontSize: "12px" }}>
                                              <th>SlNo.</th>
                                              <th>Product</th>
                                              <th>Qty</th>
                                              <th>Date</th>
                                              <th>Net Value</th>
                                              <th>GST(%)</th>
                                              <th>Tax Amt</th>
                                              <th>Gross Amt</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {editServiceItems.map(
                                              (row, index) => (
                                                <tr key={index}>
                                                  <td
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {row?.equipmentItemNr}
                                                  </td>
                                                  <td>
                                                    <p
                                                      className="m-0 p-0 fw-bold"
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      {row?.materialDescription}
                                                    </p>
                                                    <p
                                                      className="m-0 p-0"
                                                      style={{
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      {row?.materialCode}
                                                    </p>
                                                  </td>
                                                  <td>
                                                    <InputField
                                                      type="number"
                                                      className="inputBox"
                                                      value={
                                                        row?.orderedQuantity
                                                      }
                                                      onChange={(e) =>
                                                        handleLineItemChange(
                                                          "service",
                                                          index,
                                                          "orderedQuantity",
                                                          e.target.value,
                                                        )
                                                      }
                                                    />
                                                    <p
                                                      className="m-0 p-0 text-muted small"
                                                      style={{
                                                        fontSize: "10px",
                                                      }}
                                                    >
                                                      {row?.orderUnitOfMeasure}
                                                    </p>
                                                  </td>
                                                  <td>
                                                    <InputField
                                                      type="date"
                                                      className="inputBox"
                                                      value={row?.fromDate}
                                                      onChange={(e) =>
                                                        handleLineItemChange(
                                                          "service",
                                                          index,
                                                          "fromDate",
                                                          e.target.value,
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                  <td
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {row?.netValue}
                                                  </td>
                                                  <td>
                                                    <InputField
                                                      type="number"
                                                      className="inputBox"
                                                      value={row?.taxPercentage}
                                                      onChange={(e) =>
                                                        handleLineItemChange(
                                                          "service",
                                                          index,
                                                          "taxPercentage",
                                                          e.target.value,
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                  <td
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {row?.taxAmount}
                                                  </td>
                                                  <td
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {row?.grossValue}
                                                  </td>
                                                </tr>
                                              ),
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    )}
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Service Totals */}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible12
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility12}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">SD</span>
                            </Col>
                            <Col xs={4} md={4} lg={4}>
                              <span className="headerTitle">
                                Service details
                              </span>
                              <span className="subHeaderTitle">
                                Service details
                              </span>
                            </Col>
                          </Row>
                        </h2>
                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible12 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <div className="accordion-body">
                                  <Row className="pt-2 pb-4">
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Net Total"
                                        name="serviceNetTotal"
                                        id="serviceNetTotal"
                                        value={
                                          isEditMode
                                            ? calculateGlobalTotals(
                                                editServiceItems,
                                              ).netTotal
                                            : invoiceData?.serviceNetTotal
                                        }
                                        onChange={onInputChange}
                                        disabled={true}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Total GST"
                                        name="serviceTaxTotal"
                                        id="serviceTaxTotal"
                                        value={
                                          isEditMode
                                            ? calculateGlobalTotals(
                                                editServiceItems,
                                              ).taxTotal
                                            : invoiceData?.serviceTaxTotal
                                        }
                                        onChange={onInputChange}
                                        disabled={true}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Gross Total"
                                        name="serviceGrossTotal"
                                        id="serviceGrossTotal"
                                        value={
                                          isEditMode
                                            ? calculateGlobalTotals(
                                                editServiceItems,
                                              ).grossTotal
                                            : invoiceData?.serviceGrossTotal
                                        }
                                        onChange={onInputChange}
                                        disabled={true}
                                      />
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

              {isEquipmentServiceVisit && (
                <>
                  {/* Accordion A: Equipment Service Reference */}
                  <div className="accordion mb-4">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible7
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                              }`}
                              onClick={toggleCardVisibility7}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">SV</span>
                          </Col>
                          <Col xs={4} md={4} lg={4}>
                            <span className="headerTitle">
                              Equipment Service Reference
                            </span>
                          </Col>
                        </Row>
                      </h2>
                      <div
                        className={`accordion-collapse collapse show ${
                          isCardVisible7 ? "visible" : ""
                        }`}
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Source Service No"
                                value={
                                  invoiceData?.sourceServiceNr ||
                                  invoiceData?.erfServiceNumber ||
                                  ""
                                }
                                disabled
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Parent ERF"
                                value={invoiceData?.equipmentNr || ""}
                                disabled
                              />
                            </Col>
                            {invoiceData?.equipmentExtNr && (
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Parent Extension"
                                  value={invoiceData.equipmentExtNr}
                                  disabled
                                />
                              </Col>
                            )}
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Service Date / Time"
                                value={`${invoiceData?.serviceDate || ""} ${invoiceData?.serviceTime || ""}`}
                                disabled
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Service Executive"
                                value={invoiceData?.serviceProviderName || "--"}
                                disabled
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Service Category"
                                value={invoiceData?.serviceCategory || ""}
                                disabled
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Accordion B: Service Visit Items */}
                  <div className="accordion mb-4">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible7
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                              }`}
                              onClick={toggleCardVisibility7}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">SI</span>
                          </Col>
                          <Col xs={10} md={8} lg={6}>
                            <span className="headerTitle">Service Items</span>
                            <span className="subHeaderTitle">
                              Materials handled during the visit
                            </span>
                          </Col>
                        </Row>
                      </h2>
                      <div className="accordion-collapse collapse show visible">
                        <div className="accordion-body">
                          <DataTable
                            columns={equipmentServiceColumns}
                            data={
                              invoiceData?.serviceItems ||
                              invoiceData?.serviceRequiredItems ||
                              invoiceData?.items ||
                              []
                            }
                            pagination
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Accordion C: Service Visit Charges */}
                  <div className="accordion mb-4">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${
                                isCardVisible7
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                              }`}
                              onClick={toggleCardVisibility7}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">SC</span>
                          </Col>
                          <Col xs={10}>
                            <span className="headerTitle">Service Charges</span>
                          </Col>
                        </Row>
                      </h2>
                      <div className="accordion-collapse collapse show visible">
                        <div className="accordion-body">
                          <Row>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Net Amount"
                                value={Number(
                                  invoiceData?.serviceNetTotal || 0,
                                ).toFixed(2)}
                                disabled
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="GST Amount"
                                value={Number(
                                  invoiceData?.serviceTaxTotal || 0,
                                ).toFixed(2)}
                                disabled
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Gross Total"
                                value={Number(
                                  invoiceData?.serviceGrossTotal || 0,
                                ).toFixed(2)}
                                disabled
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          </div>

          <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isCardVisible8 ? "bi-chevron-right" : "bi-chevron-down"
                      }`}
                      onClick={toggleCardVisibility8}
                    ></i>
                  </Col>
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">DS</span>
                  </Col>

                  <Col xs={4} md={4} lg={4}>
                    <span className="headerTitle">Signature</span>
                    <span className="subHeaderTitle">Signature</span>
                  </Col>
                </Row>
              </h2>

              <div
                // id="acc"
                className={`accordion-collapse collapse show ${
                  isCardVisible8 ? "visible" : ""
                }`}
              >
                <div className="accordion-body">
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={6}
                            lg={8}
                            className="commTopButtonRightLeftPadding"
                          >
                            {/* <label className="fw-bold mb-2 d-block">Digital Signature</label> */}

                            <div className="d-flex gap-4">
                              <div>
                                <label className="px-2" htmlFor="digitalSign1">
                                  Deputy Manager
                                </label>
                                <input
                                  type="checkbox"
                                  id="digitalSign1"
                                  name="digitalSign1"
                                  checked={invoiceData?.digitalSign1 || false}
                                  onChange={(e) => {
                                    const { checked } = e.target;
                                    setInvoiceData((prev) => ({
                                      ...prev,
                                      digitalSign1: checked,
                                      digitalSign2: false,
                                      digitalSign3: false,
                                    }));
                                  }}
                                />
                              </div>

                              <div>
                                <label className="px-2" htmlFor="digitalSign2">
                                  Sr.Executive A/c
                                </label>
                                <input
                                  type="checkbox"
                                  id="digitalSign2"
                                  name="digitalSign2"
                                  checked={invoiceData?.digitalSign2 || false}
                                  onChange={(e) => {
                                    const { checked } = e.target;
                                    setInvoiceData((prev) => ({
                                      ...prev,
                                      digitalSign1: false,
                                      digitalSign2: checked,
                                      digitalSign3: false,
                                    }));
                                  }}
                                />
                              </div>

                              <div>
                                <label className="px-2" htmlFor="digitalSign3">
                                  Account Executive
                                </label>
                                <input
                                  type="checkbox"
                                  id="digitalSign3"
                                  name="digitalSign3"
                                  checked={invoiceData?.digitalSign3 || false}
                                  onChange={(e) => {
                                    const { checked } = e.target;
                                    setInvoiceData((prev) => ({
                                      ...prev,
                                      digitalSign1: false,
                                      digitalSign2: false,
                                      digitalSign3: checked,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <Row>
                              <Col
                                sm={12}
                                md={12}
                                lg={12}
                                className="commTopButtonRightLeftPadding d-flex justify-content-start"
                              >
                                {/* Show preview of selected signature */}
                                {invoiceData?.digitalSign1 && (
                                  <img
                                    src={signImages.digitalSign1}
                                    // src="https://static.vecteezy.com/system/resources/thumbnails/019/641/478/small/sale-3d-label-promotion-banner-png.png"
                                    alt="signature"
                                    className="img-fluid"
                                    style={{
                                      width: "240px",
                                      height: "100px",
                                      objectFit: "contain",
                                      border: "1px solid black",
                                      borderRadius: "4px",
                                    }}
                                  />
                                )}

                                {invoiceData?.digitalSign2 && (
                                  <img
                                    src={signImages.digitalSign2}
                                    alt="signature"
                                    className="img-fluid"
                                    style={{
                                      width: "240px",
                                      height: "100px",
                                      objectFit: "contain",
                                      border: "1px solid black",
                                      borderRadius: "4px",
                                    }}
                                  />
                                )}

                                {invoiceData?.digitalSign3 && (
                                  <img
                                    src={signImages.digitalSign3}
                                    alt="signature"
                                    className="img-fluid"
                                    style={{
                                      width: "240px",
                                      height: "100px",
                                      objectFit: "contain",
                                      border: "1px solid black",
                                      borderRadius: "4px",
                                    }}
                                  />
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>

          <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isCardVisible9 ? "bi-chevron-right" : "bi-chevron-down"
                      }`}
                      onClick={toggleCardVisibility9}
                    ></i>
                  </Col>
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">IF</span>
                  </Col>

                  <Col xs={4} md={4} lg={4}>
                    <span className="headerTitle">
                      Information to be filled
                    </span>
                    <span className="subHeaderTitle">
                      Information to be filled
                    </span>
                  </Col>
                </Row>
              </h2>

              <div
                // id="acc"
                className={`accordion-collapse collapse show ${
                  isCardVisible9 ? "visible" : ""
                }`}
              >
                <div className="accordion-body">
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Accounts Status"
                              extraLabel=""
                              name="accountsStatus"
                              code="accountsStatusCode"
                              description="accountsStatusDesc"
                              data={accountsStatusNumberData}
                              id="accountsStatus"
                              iconClassName="dropdownIcon"
                              setValue={invoiceData?.accountsStatus}
                              getvalue={setDropdownData}
                              required={false}
                              disabled={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Credit Note Number"
                              name="creditNoteNumber"
                              id="creditNoteNumber"
                              value={invoiceData?.creditNoteNumber}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Accounts Remarks"
                              name="accountsRemarks"
                              id="accountsRemarks"
                              value={invoiceData?.accountsRemarks}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="e-Way Bill Number"
                              extraLabel=""
                              name="ewayBill"
                              code="ewayBillCode"
                              description="ewayBillDesc"
                              data={ewayBillNumberData}
                              id="ewayBill"
                              iconClassName="dropdownIcon"
                              setValue={invoiceData?.ewayBill}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={true}
                            />
                          </Col>
                          {!invoiceData?.invoiceCreated && (
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <Row>
                                {/*    <Col xs={10} md={10} lg={10}>
                              <FileUploadComponent
                                id="creditNoteAttachment"
                                name="creditNoteAttachment"
                                label="Credit Note"
                                allowedTypes={["image/png", "image/jpeg"]}
                                multiple={false}
                                required={false}
                                onSuccessUpload={onSuccessUploadCreditNoteCard}
                                value={invoiceData?.creditNoteAttachment || ""}
                              />
                            </Col> */}
                              </Row>
                            </Col>
                          )}
                          {invoiceData?.invoiceCreated && (
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              ></Col>
                              {/* <Row>                    
                            <Col
                              xs={2}
                              md={2}
                              lg={2}
                              className="d-flex align-items-center"
                            >
                              {invoiceData?.creditNoteAttachment && (
                                <>
                                  <img
                                    src="assets/img/medirent/invoicesign/sign3actex.png"
                                    className="attachmentIcon me-2"
                                    alt="view"
                                    onClick={() =>
                                      handleViewFile(
                                        invoiceData?.creditNoteAttachment,
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                    title="View signature "
                                  />                              
                                </>
                              )}
                            </Col>
                          </Row> */}
                            </Col>
                          )}
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isCardVisible10 ? "bi-chevron-right" : "bi-chevron-down"
                      }`}
                      onClick={toggleCardVisibility10}
                    ></i>
                  </Col>
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">IF</span>
                  </Col>

                  <Col xs={4} md={4} lg={4}>
                    <span className="headerTitle">
                      Refund Information to be filled
                    </span>
                    <span className="subHeaderTitle">
                      Refund Information to be filled
                    </span>
                  </Col>
                </Row>
              </h2>

              <div
                // id="acc"
                className={`accordion-collapse collapse show ${
                  isCardVisible10 ? "visible" : ""
                }`}
              >
                <div className="accordion-body">
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Refund Status"
                              extraLabel=""
                              name="accountsRefundStatus"
                              code="accountsRefundStatusCode"
                              description="accountsRefundStatusDesc"
                              data={accountsStatusNumberData}
                              id="accountsRefundStatus"
                              iconClassName="dropdownIcon"
                              setValue={invoiceData?.accountsRefundStatus}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Remarks"
                              name="accountsRefundRemarks"
                              id="accountsRefundRemarks"
                              value={invoiceData?.accountsRefundRemarks}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/*  <div className="d-block">
        <ErfRentPrintInvoiceLazy
          ref={contentRef}
          data={printInvoiceData}
          companyDetails={companyDetails}
          onsendinvoicedata={printInvoiceDataChild}
        />
      </div> */}

      {/* <div className="d-block">
        <ErfSalePrintInvoiceLazy
          ref={contentRef}
          data={printInvoiceData}
          companyDetails={companyDetails}
          onsendinvoicedata={printInvoiceDataChild}
        />
      </div> */}

      {/* Modal Workflow */}
      <ApproveRemarksModal
        show={modalShow}
        // onHide={() => hideModal()}
        // onvaluechange={ha
        // ndleValueChange}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />

      {/* Success Modal Workflow */}
      {/* <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
        nextnavigate={getNextNavigate}
      /> */}
    </main>
  );
};

export default ERFInvoiceDetailsV5;
